<section id="dialogSection">
    <div class="control-card-white">

        <div class="control-card-header">
            <ng-container i18n="@@add_automation_dialog_title_add">Aggiungi automazione</ng-container>
            <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
        </div>

        <div id="content" class="control-card-content">

            <div fxLayout="row" fxLayoutAlign="start start">

                <div fxFlex="60" class="table-container">

                    <table mat-table matSort #deviceslisttable class="simple-table">

                        <ng-container matColumnDef="serial">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef
                                i18n="@@add_automation_dialog_tableHeader_serial" style="width: 5%;">Seriale
                            </th>
                            <td mat-cell *matCellDef="let device"> {{ device.serial }} </td>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                i18n="@@add_automation_dialog_tableHeader_description" style="width: 25%;">
                                Descrizione</th>
                            <td mat-cell *matCellDef="let device"> {{ device.name }} </td>
                        </ng-container>

                        <ng-container matColumnDef="checkbox">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let device" style="width: 5%;">
                                <mat-checkbox (change)=addSelectedDevice(device) [checked]=device.selected>
                                </mat-checkbox>
                                <!-- [disabled]="(deviceSelected && !device.selected) || editing" -->
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>


                <div fxFlex="5">
                    <!-- Spazio vuoto -->
                </div>


                <!-- <br> -->
                <div fxFlex="30" id="optionsDiv">

                    <div id="datesDiv" class="date-wrapper">


                        <!-- Con indicazione inizio/fine oraria -->

                        <div id="fromDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@add_automation_start_date">
                                Data di inizio:
                            </p>
                            <input id="from-datepicker-input" [min]="minDate" [readonly]=true
                                [ngxMatDatetimePicker]="fromDatepicker" [(ngModel)]="automation.startDate"
                                [formControl]="fromFormControl">
                            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
                            <ngx-mat-datetime-picker #fromDatepicker [stepMinute]="1">
                            </ngx-mat-datetime-picker>
                        </div>


                        <div id="toDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@add_automation__end_date">
                                Data di fine:
                            </p>
                            <input id="from-datepicker-input" [min]="minDate" [readonly]=true
                                [ngxMatDatetimePicker]="toDatePicker" [(ngModel)]="automation.expirationDate "
                                [formControl]="toFormControl">
                            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                            <ngx-mat-datetime-picker #toDatePicker [stepMinute]="1">
                            </ngx-mat-datetime-picker>

                        </div>


                        <!-- Senza indicazione inizio/fine oraria -->

                        <!-- <div id="fromDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@add_automation_start_date">
                                Data di inizio:
                            </p>
                            <input id="from-datepicker-input" [readonly]=true [matDatepicker]="fromDatepicker"
                                value="{{ automation?.startDate }}" [formControl]="fromFormControl">
                            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #fromDatepicker></mat-datepicker>
                        </div>

                        <div id="toDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@add_automation__end_date">
                                Data di fine:
                            </p>
                            <input id="to-datepicker-input" [readonly]=true [matDatepicker]="toDatepicker"
                                value="{{ automation?.expirationDate  }}" [formControl]="toFormControl">
                            <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #toDatepicker></mat-datepicker>
                        </div> -->

                    </div>

                    <br>

                    <div id="daysDiv">
                        <p class="text-small text-dark" i18n="@@add_automation_validity_days">
                            Giorni di validità:
                        </p>

                        <div class="weekdays">
                            <div class="single-day">
                                <label class="container-check">
                                    <input type="checkbox" [checked]="allDays[0]" (change)="onDayChanged(1,$event)" />
                                    <span class="checkmark clickable"></span>
                                </label>
                                <span i18n="@@day_short_monday">Lun</span>
                            </div>
                            <div class="single-day">
                                <label class="container-check">
                                    <input type="checkbox" [checked]="allDays[1]" (change)="onDayChanged(2,$event)" />
                                    <span class="checkmark clickable"></span>
                                </label>
                                <span i18n="@@day_short_tuesday">Mar</span>
                            </div>
                            <div class="single-day">
                                <label class="container-check">
                                    <input type="checkbox" [checked]="allDays[2]" (change)="onDayChanged(3,$event)" />
                                    <span class="checkmark clickable"></span>
                                </label>
                                <span i18n="@@day_short_wednesday">Mer</span>
                            </div>
                            <div class="single-day">
                                <label class="container-check">
                                    <input type="checkbox" [checked]="allDays[3]" (change)="onDayChanged(4,$event)" />
                                    <span class="checkmark clickable"></span>
                                </label>
                                <span i18n="@@day_short_thursday">Gio</span>
                            </div>
                            <div class="single-day">
                                <label class="container-check">
                                    <input type="checkbox" [checked]="allDays[4]" (change)="onDayChanged(5,$event)" />
                                    <span class="checkmark clickable"></span>
                                </label>
                                <span i18n="@@day_short_friday">Ven</span>
                            </div>
                            <div class="single-day">
                                <label class="container-check">
                                    <input type="checkbox" [checked]="allDays[5]" (change)="onDayChanged(6,$event)" />
                                    <span class="checkmark clickable"></span>
                                </label>
                                <span i18n="@@day_short_saturday">Sab</span>
                            </div>
                            <div class="single-day">
                                <label class="container-check">
                                    <input type="checkbox" [checked]="allDays[6]" (change)="onDayChanged(7,$event)" />
                                    <span class="checkmark clickable"></span>
                                </label>
                                <span i18n="@@day_short_sunday">Dom</span>
                            </div>
                        </div>
                    </div>

                    <br>

                    <div id="hoursDiv">
                        <div id="hoursTable">
                            <p class="text-small text-dark" i18n="@@add_automations_dialog_validity_timetables">
                                Orari apertura varco:
                            </p>

                            <table class="table-time-slot">
                                <tbody>
                                    <tr *ngFor="let timeSlot of automation?.timeSlots; let i = index">
                                        <td>
                                            <ng-container i18n="@@time_slot_from">Dalle</ng-container> {{
                                            timeSlot?.getFromHourMin() }}
                                            <ng-container i18n="@@time_slot_to">alle</ng-container> {{
                                            timeSlot?.getToHourMin() }}
                                        </td>
                                        <td>
                                            <fa-icon icon="trash" class="float-right margin-right-20 icon-clickable"
                                                (click)="deleteTimeSlot(i)">
                                            </fa-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="" *ngIf="automation?.timeSlots?.length == 0"
                                i18n="@@add_automation_dialog_validity_all_day">
                                Valida tutto il giorno
                            </div>

                            <a id="addTimeSlotButton" class="button-small button-grey margin-top-10"
                                (click)="addTimeSlot()">
                                <ng-container i18n="@@add_automation_dialog_add_time_slot">Aggiungi fascia
                                    oraria</ng-container>
                                <span>
                                    <fa-icon icon="plus-circle"></fa-icon>
                                </span>
                                <br>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <br>

            <div fxLayout="row" fxLayoutAlign="start center">
                <div fxFlex="20">
                    <p i18n="@@add_automation_dialog_description">Descrizione: </p>
                </div>
                <div fxFlex>
                    <input id="description-input" [(ngModel)]="description" />

                </div>
            </div>

        </div>

    </div>

    <div class="control-card-buttons">
        <br>
        <div>
            <a id="saveButton" (click)="addAutomation()" class="button">
                <ng-container i18n="@@add_automation_dialog_save">Conferma</ng-container> <span>
                    <fa-icon icon="save"></fa-icon>
                </span>
            </a>

            <a id="closeButton" (click)="closeDialog()" class="button button-red">
                <ng-container i18n="@@add_automation_dialog_discard">Cancella</ng-container> <span>
                    <fa-icon icon="trash"></fa-icon>
                </span>
            </a>



        </div>

        <div id="errorsSpacerDiv" *ngIf="!noDeviceSelectedError" fxLayout="row" fxLayoutAlign="center start">
        </div>

        <div id="errorsDiv" *ngIf="noDeviceSelectedError" fxLayout="row" fxLayoutAlign="center center">
            <p class="text-small text-error" *ngIf="noDeviceSelectedError"
                i18n="@@add_automation_no_device_selected_error">Nessun
                dispositivo selezionato</p>
        </div>

    </div>
    <app-loading-screen #loader [loading]="false"></app-loading-screen>
</section>